import { render } from "./ReactionButton.vue?vue&type=template&id=32aa1073&scoped=true&ts=true&lang=pug"
import script from "./ReactionButton.vue?vue&type=script&lang=ts"
export * from "./ReactionButton.vue?vue&type=script&lang=ts"

import "./ReactionButton.vue?vue&type=style&index=0&id=32aa1073&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32aa1073"]])

export default __exports__